
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

import { addToChainBefore, ApiHandler, HasOnError, HasOnSuccess, markSkipOnCompleteIfOnErrorIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    updateBillTo as updateBillToApi,
    UpdateBillToApiParameter,
} from "@insite/client-framework/Services/CustomersService";
import { chain,SendDataToApi } from "@insite/client-framework/Store/Data/BillTos/Handlers/UpdateBillTo";

type HandlerType = ApiHandler<UpdateBillToApiParameter & HasOnSuccess & HasOnError, BillToModel>;

export const ResetAddressValidationError: HandlerType = props => {
    (props.dispatch as any)({
        type: "Custom/AddressValidation/SetAddressValidationError",
        isErrorOccured: false,
        smartyErrorMessage: "",
    });
};

export const SendDataToApiCustom: HandlerType = async props => {
  
    if (props.apiParameter.isEdit) {
        try{
            props.apiResult = await updateBillToApi(props.apiParameter);
        }catch(result){


        (props as any).dispatch ({
            type: "Custom/AddressValidation/SetAddressValidationError",
            isErrorOccured: true, // or result if it contains error info
            smartyErrorMessage: result?.errorMessage
        });
       
        (props as any).dispatch ({
            type: "Pages/OnePageCheckout/BeginUpdateBillToError",         
        });
       

        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(result);
        
        }
       
    } else {
        props.apiResult = props.apiParameter.billTo;
    }

};

addToChainBefore(chain, SendDataToApi, ResetAddressValidationError);
replaceInChain(chain, SendDataToApi, SendDataToApiCustom);